import React from "react"
import SEO from "./seo"

export const PageMeta = ({
  metaDescription,
  metaTitle,
  metaKeywords,
  robots,
}) => {
  return (
    <SEO
      title={metaTitle}
      description={metaDescription}
      keywords={metaKeywords}
      metaRobots={robots}
    />
  )
}
